import React from 'react';
import { DatePicker, DatePickerProps } from '@mui-pickers-real';
import { IconButtonProps } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import {
	useDisableFocusTrapWithChatProps
} from '@components/ChatAwareComponents/utilities/hooks/useDisableFocusTrapWithChatProps/useDisableFocusTrapWithChatProps';

const useStyles = makeStyles((theme) => ({
	popoverPaper: {
		'& .MuiPickersCalendarHeader-dayLabel': {
			color: theme.palette.text.primary,
			fontWeight: 600,
		},
	},
}));

const buildMonthNavArrowButtonProps = (
	ariaLabel: string,
	arrowButtonProps?: IconButtonProps,
): IconButtonProps => ({
	'color': 'primary',
	'size': 'small',
	'aria-label': ariaLabel,
	...arrowButtonProps,
});

export const ChatAwareDatePicker: React.FC<DatePickerProps> = ({ children, ...rest }) => {
	const classes = useStyles();
	const disableFocusTrapWithChatProps = useDisableFocusTrapWithChatProps();
	const {
		PopoverProps,
		leftArrowButtonProps,
		rightArrowButtonProps,
		...datePickerProps
	} = rest;

	const leftArrowButtonA11yProps = buildMonthNavArrowButtonProps(
		'Previous month',
		leftArrowButtonProps,
	);

	const rightArrowButtonA11yProps = buildMonthNavArrowButtonProps(
		'Next month',
		rightArrowButtonProps,
	);

	return (
		<DatePicker
			PopoverProps={{
				...disableFocusTrapWithChatProps,
				PaperProps: {
					...PopoverProps?.PaperProps,
					className: clsx(PopoverProps?.PaperProps?.className, classes.popoverPaper),
				},
				...PopoverProps,
			}}
			leftArrowButtonProps={leftArrowButtonA11yProps}
			rightArrowButtonProps={rightArrowButtonA11yProps}
			{...datePickerProps}
		>
			{children}
		</DatePicker>
	);
};
